import React from "react";
import { Element, htmlToDOM } from "html-react-parser";
import RichTextContent, {
  richTextStyles,
} from "@/components/ui/RichTextContent";
import { isInlineHtml } from "@/utils/inline-text";

/** A heading or title as the CMS stores it: plain text as is, inline HTML sanitized to marks and line breaks. */
export default function InlineText({ value }: { value?: string | null }) {
  if (!value) return null;
  return isInlineHtml(value) ? (
    <RichTextContent html={value} inline />
  ) : (
    <React.Fragment>{value}</React.Fragment>
  );
}

/**
 * The style for the heading or title element around InlineText. The CMS stores a heading's Linjeafstand as one span around
 * the whole text, and it belongs on the heading itself, because a span inside a block cannot lower its line height.
 */
export function inlineTextStyle(
  value?: string | null,
): React.CSSProperties | undefined {
  if (!value || !isInlineHtml(value)) return;
  const nodes = htmlToDOM(value);
  const [span] = nodes;
  if (nodes.length !== 1 || !(span instanceof Element) || span.name !== "span")
    return;
  const { lineHeight } = richTextStyles(span.attribs.style);
  return lineHeight ? { lineHeight } : undefined;
}
